<div class="countable-dialog confirmation-dailog upload-img-popup" (click)="$event.stopPropagation()">
  <div mat-dialog-title class="dialog-header d-flex flex-column align-items-start gap-8 p-4">
    <span class="badge badge-primary badge-circle icon-bordered-primary">
      <i class="fa-regular fa-image text-primary"></i>
    </span>
    <h4 class="title pt-2">{{ dialogueHeading() }}</h4>
    <p>{{ subHeading() }}</p>

  </div>

  <div mat-dialog-content class="content dialog-body-content text-center gap-8 px-5">
    <div class="badge badge-primary upload-img-show px-3">
      <span class="d-flex align-items-center gap-8">
        <i class="fa-regular fa-file fs-18"></i>
        <p>{{ imageName().length > 30 ? imageName().slice(0, 30) + '...' : imageName() }}</p>
      </span>

      <input type="file" #fileInput (change)="onFileChanged($event)" accept="image/jpeg,image/jpg,image/png,image/webp,image/gif" style="display: none;">
      <button mat-button color="error" class="close button-text" (click)="fileInput.click()">
        <i class="fa-regular fa-circle-xmark clear-icon"></i>
      </button>
    </div>

      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1"
        [cropperMinWidth]="100" [cropperMinHeight]="100" [transform]="transform" format="png" [roundCropper]="true"
        [resizeToWidth]="100" [resizeToHeight]="100" (imageCropped)="onImageCropped($event)" style="height:212px"></image-cropper>

    <mat-slider min="0.5" max="1.5" step="0.01" class="image-zoom-slider">
      <input matSliderThumb [formControl]="scaleControl" />
    </mat-slider>


  </div>

  <div mat-dialog-actions class="dialog-footer button-group" (click)="$event.stopPropagation()">
    <button mat-button mat-stroked-button color="dark" class="button-normal" (click)="onCancel()">Cancel</button>
    <button mat-button mat-flat-button color="primary" class="button-normal" (click)="onSave()">Crop & Update</button>
  </div>
</div>